import { userInfo } from '@/commonTypes';
import React from 'react';
import styles from '../../../styles.module.css';

export default function UserInfo({
  item,
  userNameClass,
  showRole = false,
}: {
  item?: undefined | { user?: { name?: string; role?: string } };
  userNameClass?: string;
  showRole?: boolean;
}) {
  return (
    <span className={`${styles.userInformation} ${userNameClass}`}>
      {item?.user?.name}
      {item?.user?.role && showRole && (
        <>
          <span>{item?.user?.role}</span>
        </>
      )}
    </span>
  );
}
